import React, { useState } from "react";
import { useLocation } from "react-router-dom";

const Checkout = () => {
  const { state: product } = useLocation();

  const [form, setForm] = useState({
    name: "",
    phone: "",
    address: "",
  });

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleOrder = () => {
    const sellerNumber = "923435628108";

    const message = `
🛒 New Order

Product: ${product.name}
Price: Rs ${product.price}

Customer Name: ${form.name}
Phone: ${form.phone}
Address: ${form.address}
`;

    const whatsappURL =
      `https://wa.me/${sellerNumber}?text=${encodeURIComponent(message)}`;

    window.open(whatsappURL, "_blank");
  };

  return (
    <div className="max-w-7xl mx-auto p-6">

      <div className="grid md:grid-cols-2 gap-10">

        {/* Form */}

        <div className="bg-white shadow rounded-xl p-6">

          <h2 className="text-2xl font-bold mb-6">
            Customer Information
          </h2>

          <input
            type="text"
            name="name"
            placeholder="Full Name"
            onChange={handleChange}
            className="w-full border p-3 mb-4 rounded"
          />

          <input
            type="text"
            name="phone"
            placeholder="Phone Number"
            onChange={handleChange}
            className="w-full border p-3 mb-4 rounded"
          />

          <textarea
            name="address"
            placeholder="Complete Address"
            onChange={handleChange}
            className="w-full border p-3 mb-4 rounded"
            rows="4"
          />

          <button
            onClick={handleOrder}
            className="w-full bg-green-600 text-white py-3 rounded-lg"
          >
            Confirm Order
          </button>

        </div>

        {/* Product Details */}

        <div className="bg-white shadow rounded-xl p-6">

          <img
            src={product.image}
            alt={product.name}
            className="w-full h-72 object-contain"
          />

          <h2 className="text-2xl font-bold mt-5">
            {product.name}
          </h2>

          <p className="text-orange-600 text-3xl mt-3">
            Rs {product.price.toLocaleString()}
          </p>

        </div>

      </div>

    </div>
  );
};

export default Checkout;